import { DEV_TOUCH_STORE } from './actionTypes'

export const touchStore = () => ({
  type: DEV_TOUCH_STORE,
  meta: {},
  payload: {}
})

export default { touchStore }
